var new_cur = '$';
var sale = 1;

function changeTotalOnPage(){
  if($('.sub_price').length === 0) return;
  $.getJSON('/cart.js', function(cart){
    var total = (cart.total_price / 100).toFixed(2);
    $('.sub_price').html(new_cur + total);
    $('.cart-count, .up-cart-count, .item--cart .quantity, .header__menu_count').text(cart.item_count);
  });
}

$(document).ready(function(){
  changeTotalOnPage();
});

function setProductInfo(page_product, title_text, upsells, json_prods){
  var k = upsells.length;

  $.getJSON('/products/' + page_product + '.json', function(data){
    $('.up-img img').attr('src', data.product.image.src);
    $('.up-name').text(data.product.title);
    $('.up-title.title-insert').text(title_text);
    $('.main_product_href').attr('href', '/products/' + data.product.handle);
  });

  if(k === 0) return;

  var requests = [$.getJSON('/cart.js')];
  for(var i = 0; i < k; i++){
    requests.push($.getJSON('/products/' + upsells[i] + '.json'));
  }

  $.when.apply($, requests).done(function(){
    var args = Array.prototype.slice.call(arguments);
    var cart = args[0][0];
    var cartIds = cart.items.map(function(item){ return item.variant_id; });
    var container = $('.up-products-block').empty();

    for(var j = 1; j < args.length; j++){
      var prod = args[j][0].product;
      var link = prod.handle;
      var name = prod.title;
      var img_src = prod.image.src;
      var prod_price = prod.variants[0].price;
      var prod_price_sale = parseFloat(prod_price * sale).toFixed(2);
      var prod_id = prod.variants[0].id;

      if(cartIds.indexOf(prod_id) === -1){
        var output = '<div class="up-proditem">';
        output += '<div class="up-proditem-img"><a href="/products/' + link + '"><img src="' + img_src + '" class="' + link + '" loading="lazy"></a></div>';
        output += '<div class="up-proditem-info"><a href="/products/' + link + '"><div class="up-proditem-name">' + name + '</div></a>';
        output += '<div class="up-proditem-price"><span class="new_up_price">$' + prod_price_sale + '</span></div>';
        output += '<div class="up-proditem-button"><button class="up-add-btn" type="button" data-id="' + prod_id + '">Add to cart</button></div></div></div>';
        container.append(output);
      }
    }
  });
}

function addItem(id, qty){
  return $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {id: id, quantity: qty}
  }).done(function(){
    if(typeof cartUpdate === 'function') cartUpdate();
  });
}

$(document).on('click', '.upsell_close', function(){
  $('.upsell_overlay').hide();
  $('body').removeClass('modal_open');
});

$(document).on('click', '.up-proditem-button .up-add-btn', function(){
  var btn = $(this);
  var id = btn.data('id');
  addItem(id, 1).done(function(){
    btn.closest('.up-proditem').animate({width: 'toggle'}).promise().done(function(){
      btn.closest('.up-proditem').remove();
      changeTotalOnPage();
      if($('.up-products-block .up-proditem').length === 0){
        $('.upsell_overlay').hide();
        $('body').removeClass('modal_open');
      }
    });
  });
});

function open_upsell(upsell_array){
  $('html,body').animate({scrollTop: 0});
  $('.upsell_overlay').css('display', 'flex');
  $('body').addClass('modal_open');
}
